import {Component, ChangeDetectionStrategy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';

import {AuthUtils} from '../shared/authutils';
import {CookieUtils} from '../shared/cookieutils';
import {SystemUtils} from '../shared/systemutils';
import {SystemPaths} from '../shared/system-paths';

import {BaseComponent} from '../shared/base.component';
import {CommonModalsComponent} from '../shared/common-modals.component';

import {GetAccountByUsernameService} from '../service/get-account-by-username.service';
import {GetLeagueByAbbrService} from '../service/get-league-by-abbr.service';
import {GetSeasonsForLeagueService} from '../service/get-seasons-for-league.service';
import {GetGameSummariesForSeasonService} from '../service/get-game-summaries-for-season.service';
import {GetTeamSummariesForSeasonService} from '../service/get-team-summaries-for-season.service';

declare var System, dateFormat;

export abstract class ScheduleComponent extends BaseComponent implements OnInit {
	private authUtils: AuthUtils;
	private cookieUtils: CookieUtils;
	private systemUtils;
	private GetLeagueByAbbrService: GetLeagueByAbbrService;
	private GetSeasonsForLeagueService: GetSeasonsForLeagueService;
	private GetGameSummariesForSeasonService: GetGameSummariesForSeasonService;
	private GetTeamSummariesForSeasonService: GetTeamSummariesForSeasonService;

	private COOKIENAME_SCHEDULE_DATE: string;
	private COOKIENAME_SCHEDULE_SEASON: string;

	private controllerModel: any;

	private leagueAbbr: string;

	public  games: Array<any>;
	private teamSummaries: Array<any>;

	private league:any;
	public  seasons:Array<any>;
	public  selectedSeason:any;

	private isSelectSeasonBtnOpen:boolean;

	public  navDates: any;

	private dateSelectorOpened:boolean;
	private dateSelectorOptions:any;

	private intervalPromise: any;

	private UPDATING_GAMES_REFRESH_TIME: number;
	private LIVE_GAMES_REFRESH_TIME:number;

	public  isLoggedIn:boolean;
	public  isLoggedInAsAdministrator:boolean;
	private currentUser:any;

	protected abstract getPeriodLabel(periodNum: number, includeOrdinal: boolean, seasonType: string);

	protected abstract formatPeriodTime(periodTime: number);

	protected abstract getOutcomeSuffix(numPeriods: number, seasonType: string);

	constructor(authUtils: AuthUtils, cookieUtils: CookieUtils, systemUtils: SystemUtils, systemPaths: SystemPaths,
	            GetLeagueByAbbrService:GetLeagueByAbbrService,
				GetSeasonsForLeagueService: GetSeasonsForLeagueService,
				GetGameSummariesForSeasonService: GetGameSummariesForSeasonService,
				GetTeamSummariesForSeasonService: GetTeamSummariesForSeasonService) {

		super(systemPaths);

		this.authUtils = authUtils;
		this.cookieUtils = cookieUtils;
		this.systemUtils = systemUtils;
		
		this.GetLeagueByAbbrService = GetLeagueByAbbrService;
		this.GetSeasonsForLeagueService = GetSeasonsForLeagueService;
		this.GetGameSummariesForSeasonService = GetGameSummariesForSeasonService;
		this.GetTeamSummariesForSeasonService = GetTeamSummariesForSeasonService;

		this.controllerModel = {
			initialized: false
		};

		this.games = [];

		this.teamSummaries = null;

		this.league = null;
		this.seasons = [];
		this.selectedSeason = null;

		this.isSelectSeasonBtnOpen = false;

		this.navDates = {
			previous: null,
			current: null,
			next: null
		};

		this.dateSelectorOpened = false;
		this.dateSelectorOptions = {
			startingDay: 0,
			showWeeks: false
		};

		this.intervalPromise = null;

		this.UPDATING_GAMES_REFRESH_TIME = 60 * 5;
		this.LIVE_GAMES_REFRESH_TIME = 10;

		this.selectedSeason = {
			name: ""
		};
	}

	public ngOnInit() {
		this.setPageEnabled(false);

		this.leagueAbbr = window.location.href.substring(0, window.location.href.indexOf("/schedule"));
		this.leagueAbbr = this.leagueAbbr.substring(this.leagueAbbr.lastIndexOf("/") + 1);

		this.COOKIENAME_SCHEDULE_DATE = this.leagueAbbr + "_schedule_date";
		this.COOKIENAME_SCHEDULE_SEASON = this.leagueAbbr + "_schedule_season";

		this.currentUser = null;
		this.authUtils.getCurrentUser().subscribe(
			currentUser => {
				this.currentUser = currentUser;

				this.isLoggedIn = this.authUtils.isLoggedIn();
				this.authUtils.isLoggedInAsAdministrator().subscribe(
					loggedInAsAdmin => {
						this.isLoggedInAsAdministrator = loggedInAsAdmin;

						this.getLeagueByAbbr(this.leagueAbbr).subscribe(
							leagueRes => {
								this.getSeasonsForLeague().subscribe(
									seasonsRes => {
										this.setPageEnabled(true);

										this.controllerModel.initialized = true;
									}
								);
							}
						);
					}
				);
			}
		);
	}

	private getLeagueByAbbr(leagueAbbr:string) {
		let obs:Observable<any> = this.GetLeagueByAbbrService.get(leagueAbbr);
		obs.subscribe(
			res => {
				this.league = res;
			}
		);

		return obs;
	}

	private getSeasonsForLeague() {
		let obs:Observable<any> = this.GetSeasonsForLeagueService.get(this.league.id);
		obs.subscribe(
			res => {
				this.seasons = res.reverse();

				if (!this.cookieUtils.getCookie(this.COOKIENAME_SCHEDULE_SEASON)) {
					this.selectSeason(this.seasons[0], true);
				} else {
					let cookieSeason: any = JSON.parse(this.cookieUtils.getCookie(this.COOKIENAME_SCHEDULE_SEASON));
					let isSeasonAvailable: boolean = false;
					this.seasons.forEach(function(seasonEntry) {
						if ( seasonEntry.id === cookieSeason.id ) {
							isSeasonAvailable = true;
						}
					});
					if ( isSeasonAvailable ) {
						this.selectSeason(cookieSeason, false);
					} else {
						this.selectSeason(this.seasons[0], true);
					}
				}
			}
		);

		return obs;
	}

	private decorateDates() {
		if ( this.navDates.previous ) {
			this.navDates._previousStr = dateFormat(this.navDates.previous, "mmm d");
		} else {
			this.navDates._previousStr = "";
		}
		if (this.navDates.current) {
			this.navDates._currentStr = dateFormat(this.navDates.current, "mmm d");
		} else {
			this.navDates._currentStr = "";
		}
		if (this.navDates.next) {
			this.navDates._nextStr = dateFormat(this.navDates.next, "mmm d");
		} else {
			this.navDates._nextStr = "";
		}
	}

	public selectSeason(season:any, clearCookies:boolean) {
		delete season.isScrambled;
		delete season.testingOrigEndDate;
		delete season.testingOrigStartDate;
		delete season.testingDaysOffset;
		delete season.isForTesting;
		delete season.teamStatsIncluded;
		delete season.playerStatsIncluded;

		this.selectedSeason = season;
		this.cookieUtils.setCookie(this.COOKIENAME_SCHEDULE_SEASON, JSON.stringify(this.selectedSeason), 1, '/');

		if (clearCookies) {
			this.cookieUtils.deleteCookie(this.COOKIENAME_SCHEDULE_DATE);
		}

		if (!this.cookieUtils.getCookie(this.COOKIENAME_SCHEDULE_DATE)) {
			this.navDates.current = new Date();
			this.examineCurrentNavDate();
		} else {
			this.navDates.current = new Date();
			this.navDates.current.setTime(this.cookieUtils.getCookie(this.COOKIENAME_SCHEDULE_DATE));
			this.examineCurrentNavDate();
		}
		this.navDates.current.setHours(0, 0, 0, 0);

		if (this.navDates.current <= this.systemUtils.parseSystemDate(this.selectedSeason.startDate)) {
			this.navDates.current = this.systemUtils.parseSystemDate(this.selectedSeason.startDate);
			this.navDates.current.setHours(0, 0, 0, 0);
			this.examineCurrentNavDate();
		} else if (this.navDates.current >= this.systemUtils.parseSystemDate(this.selectedSeason.endDate)) {
			this.navDates.current = this.systemUtils.parseSystemDate(this.selectedSeason.endDate);
			this.navDates.current.setHours(0, 0, 0, 0);
			this.examineCurrentNavDate();
		}

		this.navDates.previous = new Date(this.navDates.current.getTime());
		this.navDates.previous.setDate(this.navDates.previous.getDate() - 1);
		if (this.navDates.previous < this.systemUtils.parseSystemDate(this.selectedSeason.startDate)) {
			this.navDates.previous = null;
		}

		this.navDates.next = new Date(this.navDates.current.getTime());
		this.navDates.next.setDate(this.navDates.next.getDate() + 1);
		if (this.navDates.next > this.systemUtils.parseSystemDate(this.selectedSeason.endDate)) {
			this.navDates.next = null;
		}

		this.decorateDates();

		let requestObj:any = {
			leagueId: this.leagueAbbr,
			seasonId: this.selectedSeason.id,
			divisionId: null,
			includeRank: false
		};

		let obs:Observable<any> = this.GetTeamSummariesForSeasonService.get(requestObj);
		obs.subscribe(
			res => {
				this.teamSummaries = res;

				this.getGamesForSeasonAndDate();
			}
		);
	}

	private getGamesForSeasonAndDate() {
		if (this.intervalPromise) {
			clearInterval(this.intervalPromise);
		}

		let nextDate:Date = new Date(this.navDates.current.getTime());
		nextDate.setDate(nextDate.getDate() + 1);

		let requestObj:any = {
			leagueId: this.leagueAbbr,
			seasonId: this.selectedSeason.id,
			startDate: dateFormat(this.navDates.current, 'yyyy-mm-dd'),
			endDate: dateFormat(nextDate, 'yyyy-mm-dd'),
			offset: 0
		};

		let obs:Observable<any> = this.GetGameSummariesForSeasonService.get(requestObj);
		obs.subscribe(
			res => {
				this.games = [].concat(res);

				let checkEveryXSeconds:number = null;

				let todayDate:Date = new Date();
				todayDate.setHours(0, 0, 0, 0);
				if (todayDate.getTime() === this.navDates.current.getTime()) {
					checkEveryXSeconds = this.UPDATING_GAMES_REFRESH_TIME;
				}

				this.games.forEach(function(gameSummary) {
					gameSummary.game._playDateTime = this.systemUtils.parseSystemDateTime(gameSummary.game.playDateTime);

					if (gameSummary.game.playStatus === 'UPDATING' ||
						gameSummary.game.playStatus === 'PENDING_UPDATES_REVIEW') {

						if (!checkEveryXSeconds) {
							checkEveryXSeconds = this.UPDATING_GAMES_REFRESH_TIME;
						} else {
							if (checkEveryXSeconds > this.UPDATING_GAMES_REFRESH_TIME) {
								checkEveryXSeconds = this.UPDATING_GAMES_REFRESH_TIME;
							}
						}
					} else if (gameSummary.game.playStatus === 'IN_PROGRESS' ||
	                           gameSummary.game.playStatus === 'PENDING_LIVE_REVIEW') {

						if (!checkEveryXSeconds) {
							checkEveryXSeconds = this.LIVE_GAMES_REFRESH_TIME;
						} else {
							if (checkEveryXSeconds > this.LIVE_GAMES_REFRESH_TIME) {
								checkEveryXSeconds = this.LIVE_GAMES_REFRESH_TIME;
							}
						}
					}

					if (gameSummary.game.playStatus === 'COMPLETED' ||
						gameSummary.game.playStatus === 'UPDATING' ||
						gameSummary.game.playStatus === 'PENDING_UPDATES_REVIEW') {

						gameSummary.game._outcomeSuffix = this.getOutcomeSuffix(gameSummary.game.periodsComplete,
							gameSummary.game.season.type);
					} else if (gameSummary.game.playStatus === 'IN_PROGRESS') {
						if (gameSummary.gameUpdate.currentPeriod) {
							gameSummary.gameUpdate._periodOrdinal = this.getPeriodLabel(gameSummary.gameUpdate.currentPeriod, true, gameSummary.game.season.type);
							gameSummary.gameUpdate._periodTimeLeft = this.formatPeriodTime(gameSummary.gameUpdate.periodTimeLeft);
						} else if (gameSummary.gameUpdate.currentIntermission) {
							gameSummary.gameUpdate._periodOrdinal = gameSummary.gameUpdate.currentIntermission + this.systemUtils.getOrdinalSuffix(gameSummary.gameUpdate.currentIntermission) + " Int.";
						} else if (!gameSummary.gameUpdate.currentPeriod && !gameSummary.gameUpdate.currentIntermission) {
							gameSummary.gameUpdate._periodOrdinal = "Pre-Game";
						}
					}

					this.teamSummaries.forEach(function(teamSummary) {
						if (teamSummary.teamCtx.team.id === gameSummary.game.awayTeamCtx.team.id) {
							gameSummary.game.awayTeamCtx._record = this.generateRecord(teamSummary);
						}

						if (teamSummary.teamCtx.team.id === gameSummary.game.homeTeamCtx.team.id) {
							gameSummary.game.homeTeamCtx._record = this.generateRecord(teamSummary);
						}
					}.bind(this));
				}.bind(this));

				if (checkEveryXSeconds) {
					this.intervalPromise = setInterval(
						() => {
							this.getGamesForSeasonAndDate();
					}, checkEveryXSeconds * 1000);
				}
			}
		);

		return obs;
	}

	public showPreviousDay() {
		if (!this.navDates.next) {
			this.navDates.next = new Date(this.navDates.current.getTime());
		} else {
			this.navDates.next.setDate(this.navDates.next.getDate() - 1);
		}
		this.navDates.current.setDate(this.navDates.current.getDate() - 1);
		this.examineCurrentNavDate();
		this.navDates.previous.setDate(this.navDates.previous.getDate() - 1);
		if (this.navDates.previous < this.systemUtils.parseSystemDate(this.selectedSeason.startDate)) {
			this.navDates.previous = null;
		}

		this.decorateDates();

		this.cookieUtils.setCookie(this.COOKIENAME_SCHEDULE_DATE, this.navDates.current.getTime(), 1, '/');
		this.checkForTodaysDate();

		this.getGamesForSelectedDay();
	}

	public showNextDay() {
		if (!this.navDates.previous) {
			this.navDates.previous = new Date(this.navDates.current.getTime());
		} else {
			this.navDates.previous.setDate(this.navDates.previous.getDate() + 1);
		}
		this.navDates.current.setDate(this.navDates.current.getDate() + 1);
		this.examineCurrentNavDate();
		this.navDates.next.setDate(this.navDates.next.getDate() + 1);
		if (this.navDates.next > this.systemUtils.parseSystemDate(this.selectedSeason.endDate)) {
			this.navDates.next = null;
		}

		this.decorateDates();
		
		this.cookieUtils.setCookie(this.COOKIENAME_SCHEDULE_DATE, this.navDates.current.getTime(), 1, '/');
		this.checkForTodaysDate();

		this.getGamesForSelectedDay();
	}

	private checkForTodaysDate() {
		this.navDates.current.setHours(0, 0, 0, 0);
		
		let todayDate: Date = new Date();
		todayDate.setHours(0, 0, 0, 0);
		if (todayDate.getTime() === this.navDates.current.getTime()) {
			this.cookieUtils.deleteCookie(this.COOKIENAME_SCHEDULE_DATE);
		} else {
			this.cookieUtils.setCookie(this.COOKIENAME_SCHEDULE_DATE, this.navDates.current.getTime(), 1, '/');
		}
	}

	private getGamesForSelectedDay() {
		if (this.navDates.current > this.systemUtils.parseSystemDate(this.selectedSeason.endDate)) {
			this.navDates.current = this.systemUtils.parseSystemDate(this.selectedSeason.endDate);
			this.examineCurrentNavDate();
			this.navDates.previous = this.systemUtils.parseSystemDate(this.selectedSeason.endDate);
			this.navDates.previous.setDate(this.navDates.current.getDate() - 1);
			this.navDates.next = null;
		}
		if (this.navDates.current < this.systemUtils.parseSystemDate(this.selectedSeason.startDate)) {
			this.navDates.current = this.systemUtils.parseSystemDate(this.selectedSeason.startDate);
			this.examineCurrentNavDate();
			this.navDates.previous = null;
			this.navDates.next = this.systemUtils.parseSystemDate(this.selectedSeason.startDate);
			this.navDates.next.setDate(this.navDates.current.getDate() + 1);
		}

		this.decorateDates();

		this.setPageEnabled(false);

		let obs:Observable<any> = this.getGamesForSeasonAndDate();
		obs.subscribe(
			res => {
				this.setPageEnabled(true);
			}
		);
	}

	private examineCurrentNavDate() {
		if (this.dateSelectorOpened) {
			this.navDates.previous = new Date(this.navDates.current.getTime());
			this.navDates.previous.setDate(this.navDates.previous.getDate() - 1);
			if (this.navDates.previous < this.systemUtils.parseSystemDate(this.selectedSeason.startDate)) {
				this.navDates.previous = null;
			}
			this.navDates.next = new Date(this.navDates.current.getTime());
			this.navDates.next.setDate(this.navDates.next.getDate() + 1);
			if (this.navDates.next > this.systemUtils.parseSystemDate(this.selectedSeason.endDate)) {
				this.navDates.next = null;
			}

			this.decorateDates();

			this.getGamesForSelectedDay();
		}

		if (this.navDates.current) {
			this.checkForTodaysDate();
		}
	}

	protected abstract generateRecord(teamSummary:any);

	public gotoAddGamePage() {
		document.location.href = this.systemPaths.addGame(this.leagueAbbr);
	}

	public gotoGameSummary(gameSummary: any) {
		gameSummary._isSelected = true;

		document.location.href = this.systemPaths.gameSummary(this.leagueAbbr, gameSummary.game.id);

		gameSummary._isSelected = false;
	}

	public openDateSelector($event) {
		$event.preventDefault();
		$event.stopPropagation();

		this.dateSelectorOpened = true;
	}

}
